import React, { useContext } from 'react';
import { Grid, NativeSelect, FormControl, InputLabel } from '@mui/material';
import { ChartingCodeContext } from '../lib/chartingCodeContext';
import createLabel from '../lib/createLabel';



export const SelectInput = ({ fieldConfig, value }) => {
	const { setValue } = useContext(ChartingCodeContext);

	return (
		<Grid size={{ xs: fieldConfig.grid }}>
			<FormControl fullWidth>
				<InputLabel variant="standard" htmlFor={fieldConfig.valueName}>
					{createLabel(fieldConfig)}
				</InputLabel>
				<NativeSelect
					value={value}
					inputProps={{
						name: fieldConfig.valueName,
						id: fieldConfig.valueName,
					}}
					onChange={e => setValue(fieldConfig.valueName, e.target.value)}
				>
					{fieldConfig.selectValues.map(selectValue => (
						<option key={selectValue.value} value={selectValue.value}>{selectValue.label}</option>
					))}
				</NativeSelect>
			</FormControl>
		</Grid>
	);
};

export default SelectInput;
